import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({ id, image, titulo, data, desc }) {
  const apiUrl = "https://api.institucional.global.sidom.io";
  return (
    <div className="group h-[400px] ">
      <div className="relative overflow-hidden rounded-xl h-[200px] shadow-md dark:shadow-gray-700">
        <img
          src={`${apiUrl}${image}`}
          className=""
          alt={titulo || "Blog image"}
        />
      </div>
      <div className="p-4">
        <Link
          to={`/blog-detail/${id}`}
          className="title text-lg font-medium hover:text-orange-500 duration-500"
        >
          {titulo}
        </Link>
        <p className="text-slate-400 dark:text-white/60 mt-3">{desc}</p>
        <div className="mt-3">
          <Link to={`/blog-detail/${id}`} className="hover:text-orange-500">
            Leer más <i className="mdi mdi-arrow-right align-middle"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}
